/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  Avatar,
  Image,
  Spin,
  notification,
  Empty,
  DatePicker,
  Menu,
  DatePickerProps,
} from "antd";

// Locales
import "dayjs/locale/th";
import { APIEndpointWeb, webapi } from "@client/web";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useCookies } from "react-cookie";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
} from "@constant/constant";
import dayjs from "dayjs";
import HomeWebConfirmSelectInsurance from "../IsurerComponent/HomeWebConfirmSelectInsurance";

const { Text } = Typography;

export interface IResTopic {
  hospital_code: string;
  hospital_name: string;
  insurance_agent: string;
  insurance_name: string;
  ref_code: string;
  request_name: string;
  medical_history_id: string;
  id: string;
  request_date: string;
  logo: string;
}

export interface IPaginate {
  page: number;
  page_last: number;
  total: number;
}

const limit = 5;
let gPage = 1;

const HomeWebSelectInsurance: React.FC = (): JSX.Element => {
  const [resInsurance, setResInsurance] = useState<IResTopic[]>();
  const [loading, setLoading] = useState(false);
  const [datadefaultSelectedKeys, setdefaultSelectedKeys] = useState(["0"]);
  const [datavalueStep, setDatavalueStep] = useState([]);
  const [idStep, setIdStep] = useState(Number);
  const [resSelectdate, setResSelectdate] = useState("");
  const [WindowResize, setWindowResize] = useState(Number);
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
  ]);
  useEffect(() => {
    getapi();
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };
  const getConfirmSelect = (index: number, item: any) => {
    setIdStep(index);
    setdefaultSelectedKeys([index.toString()]);
    setDatavalueStep(item);
  };
  const getapi = async () => {
    setLoading(true);
    try {
      const { data } = await webapi.get(`${APIEndpointWeb.GetInsurance}`, {
        withCredentials: true,
        // headers: { Authorization: `Bearer ${cookies.shared_token}` },
      });
      setResInsurance(data.result);
      if (data.result.length > 0) {
        setDatavalueStep(data.result[0])
      }
      else {
        setDatavalueStep([])
      }

    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };


  return (
    <div>
      {WindowResize > 1024 && (
        <Spin tip="กำลังโหลด..." spinning={loading}>
          {resInsurance && resInsurance.length > 0 ? (
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} >
              <Row
                style={{
                  scrollbarGutter: "auto",
                }}
                className="pl-3 pr-3 "
              >
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="pt-2 pb-2 mt-5"
                  style={{
                    height: "500px",
                  }}
                >
                  <div
                    className="pt-2 pr-4 pl-4 pb-2 large-2"
                    style={{
                      height: "90%",
                    }}
                  >
                    {resInsurance && resInsurance.length > 0 ? (
                      resInsurance.map((item: any, id: number) => (
                        <>
                          <Menu
                            selectedKeys={datadefaultSelectedKeys}
                            style={{
                              borderRadius: "20px",
                              marginBottom: "20px",
                            }}
                          >
                            <Menu.Item
                              key={id}
                              onClick={(id: any) => getConfirmSelect(id.key, item)}
                              style={{
                                height: "100%",
                                borderRadius: "20px",
                                boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.25)",
                                margin: "0px",
                              }}
                              className="border-radius-10 pt-1 pb-2 test"
                            >
                              <Row
                                className="m-3"
                                justify="space-around"
                              >
                                <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                                  <Image
                                    preview={false}
                                    src={`data:image/jpeg;base64,${item.logo}`}
                                    style={{ marginTop: "5px" }}
                                    width={60}
                                  />
                                </Col>
                                <Col
                                  xs={18}
                                  sm={18}
                                  md={18}
                                  lg={18}
                                  xl={18}
                                  xxl={18}
                                  style={{ lineHeight: "25px", marginRight: "" }}
                                >
                                  <Text className="font-weight-600 size-18">
                                    {item.insurance_name}{" "}
                                  </Text>
                                  <br />
                                  <Text className="font-weight-600 size-14 ">
                                    วันที่ร้องขอ :{" "}
                                  </Text>
                                  <Text className="size-16">
                                    {dayjs(item.request_date)
                                      .subtract(7, 'hour')
                                      .add(543, "year")
                                      .format("DD/MM/YYYY")}
                                  </Text>
                                </Col>
                                {/* </Col> */}
                              </Row>
                            </Menu.Item>
                          </Menu>
                        </>
                      ))
                    ) : ''}
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="pt-2 pr-4 pl-4 pb-2 mt-5"
                  style={{
                    height: "100%",
                  }}
                >
                  {/* {resInsurance && resInsurance.length > 0 ? ( */}
                  <HomeWebConfirmSelectInsurance
                    datavalueStep={datavalueStep}
                    getapi={getapi}
                  />

                </Col>
              </Row>
            </Col>
          ) : (
            <div style={{ justifyItems: "center", marginTop: "25%" }}>
              <Empty description={"ไม่มีข้อมูล"} />
            </div>
          )}
        </Spin>
      )}
    </div>
  );
};

export default HomeWebSelectInsurance;
